import { scim } from '@talend/context';

export const isSnowflakeUser = () => {
	const debugSF = localStorage.getItem('DEBUG_SF_ONBOARDING');
	if (debugSF) {
		return JSON.parse(debugSF) as boolean;
	}
	return scim.account.getCache().partnerId === 'snowflake';
};

export const isTrialAccount = () =>
	scim.account.getCache().subscription.status === 'Evaluation' &&
	scim.account.getCache().name.startsWith('trial');
